<template>
  <q-card
    class="producto-camara-form"
    style="max-width: 100vw; height: 90vh; display: flex; flex-direction: column"
  >
    <!-- Header mejorado - FIJO -->
    <q-toolbar class="bg-gradient-primary text-white toolbar-fixed">
      <q-icon name="ac_unit" size="28px" class="q-mr-sm" />
      <q-toolbar-title>
        <div class="text-h6">{{ title }}</div>
        <div class="text-caption text-white-7">{{ producto.productoDesc }}</div>
      </q-toolbar-title>

      <!-- Badge de validación -->
      <q-badge
        :color="res.valid ? 'positive' : 'warning'"
        :label="res.valid ? 'Válido' : 'Incompleto'"
        class="q-mr-md"
      >
        <q-icon
          :name="res.valid ? 'check_circle' : 'error'"
          size="16px"
          class="q-ml-xs"
        />
      </q-badge>

      <q-btn dense flat icon="close" v-close-popup>
        <q-tooltip>Cerrar (ESC)</q-tooltip>
      </q-btn>
    </q-toolbar>

    <!-- Contenido scrolleable -->
    <div class="row no-wrap content-scrollable">
      <!-- Columna principal: Formulario -->
      <div class="col-12 col-md-8 q-pa-md scroll-area">
        <!-- Sección: Información del Producto -->
        <q-expansion-item
          default-opened
          icon="info"
          label="Información del Producto"
          header-class="bg-grey-2 text-primary text-weight-medium"
          class="q-mb-md rounded-borders overflow-hidden"
        >
          <q-card flat bordered>
            <q-card-section>
              <ProductosCommon
                v-model:empresa-id="form.empresa_id"
                v-model:alicuota-id="form.alicuota_id"
                v-model:producto-id="form.producto_id"
                v-model:tipo-venta-id="form.tipo_venta_id"
                v-model:ubicacion-id="form.ubicacion_id"
                @update:empresa-id="validate($event, 'empresa_id')"
                @update:alicuota-id="validate($event, 'alicuota_id')"
                @update:producto-id="validate($event, 'producto_id')"
                @update:tipo-venta-id="validate($event, 'tipo_venta_id')"
                @update:ubicacion-id="validate($event, 'ubicacion_id')"
                :res="res"
              />
            </q-card-section>
          </q-card>
        </q-expansion-item>

        <!-- Sección: Configuración de Cámara -->
        <q-expansion-item
          default-opened
          icon="tune"
          label="Configuración de Cámara"
          caption="Tipo y cantidad de cámaras"
          header-class="bg-grey-2 text-primary text-weight-medium"
          class="q-mb-md rounded-borders overflow-hidden"
        >
          <q-card flat bordered>
            <q-card-section>
              <div class="row q-col-gutter-md">
                <div class="col-12 col-md-6">
                  <div class="text-subtitle2 q-mb-sm text-grey-8">
                    <q-icon name="category" size="18px" class="q-mr-xs" />
                    Tipo de Cámara
                    <q-icon name="help_outline" size="16px" class="q-ml-xs">
                      <q-tooltip max-width="300px">
                        <strong>Convencional:</strong> Genera automáticamente 5 paneles (4
                        muros + 1 techo)<br />
                        <strong>No convencional:</strong> Agregar paneles manualmente
                      </q-tooltip>
                    </q-icon>
                  </div>
                  <q-option-group
                    :options="tipos"
                    type="radio"
                    inline
                    v-model="form.tipo"
                    class="modern-radio-group"
                  />
                </div>
                <div class="col-12 col-md-6">
                  <GltnInputNumber
                    v-model.number="form.cantidad"
                    label="Cantidad de cámaras"
                    hint="Número de cámaras idénticas"
                  >
                    <template v-slot:prepend>
                      <q-icon name="shopping_cart" />
                    </template>
                  </GltnInputNumber>
                </div>
              </div>

              <!-- Dimensiones para tipo Convencional -->
              <template v-if="form.tipo === 'conv'">
                <q-separator class="q-my-md" />
                <div class="text-subtitle2 q-mb-sm text-grey-8">
                  <q-icon name="straighten" size="18px" class="q-mr-xs" />
                  Dimensiones de la Cámara
                </div>
                <div class="row q-col-gutter-md">
                  <div class="col-12">
                    <GltnSelectPanel v-model="form.panel" label="Panel" tipo-panel="MC" />
                  </div>
                  <div class="col-12 col-md-3">
                    <GltnInputNumber
                      name="Largo"
                      v-model.number="form.largo"
                      label="Largo (m)"
                      @update:model-value="validate($event, 'largo')"
                      :errors="res.getErrors('largo')"
                    >
                      <template v-slot:prepend>
                        <q-icon name="height" />
                      </template>
                    </GltnInputNumber>
                  </div>
                  <div class="col-12 col-md-3">
                    <GltnInputNumber
                      name="Ancho"
                      v-model="form.ancho"
                      label="Ancho (m)"
                      @update:model-value="validate($event, 'ancho')"
                      :errors="res.getErrors('ancho')"
                    >
                      <template v-slot:prepend>
                        <q-icon name="swap_horiz" />
                      </template>
                    </GltnInputNumber>
                  </div>
                  <div class="col-12 col-md-3">
                    <GltnInputNumber
                      name="Alto"
                      v-model="form.alto"
                      label="Alto (m)"
                      @update:model-value="validate($event, 'alto')"
                      :errors="res.getErrors('alto')"
                    >
                      <template v-slot:prepend>
                        <q-icon name="expand" />
                      </template>
                    </GltnInputNumber>
                  </div>
                  <div class="col-12 col-md-3">
                    <GltnInputNumber
                      readonly
                      name="m3"
                      v-model="form.m3"
                      label="Volumen (m³)"
                      filled
                      bg-color="blue-1"
                    >
                      <template v-slot:prepend>
                        <q-icon name="calculate" />
                      </template>
                    </GltnInputNumber>
                  </div>
                  <div class="col-12">
                    <q-btn
                      unelevated
                      label="Generar Paneles Automáticamente"
                      color="primary"
                      icon="add_circle"
                      class="full-width"
                      @click="panelAdd()"
                      :disable="!form.panel || !form.largo || !form.ancho || !form.alto"
                    >
                      <q-tooltip
                        v-if="!form.panel || !form.largo || !form.ancho || !form.alto"
                      >
                        Complete todos los campos para generar paneles
                      </q-tooltip>
                      <q-tooltip v-else>
                        Genera automáticamente 5 paneles: 4 muros + 1 techo
                      </q-tooltip>
                    </q-btn>
                  </div>
                </div>
              </template>
            </q-card-section>
          </q-card>
        </q-expansion-item>

        <!-- Sección: Paneles -->
        <q-expansion-item
          :default-opened="paneles.length > 0 || form.tipo === 'nconv'"
          icon="grid_on"
          :label="`Paneles (${paneles.length})`"
          :caption="
            paneles.length > 0
              ? `Total: ${numberFormat(totalM2, true)} m² | ${numberFormat(totalPaneles)}`
              : 'Sin paneles agregados'
          "
          header-class="bg-grey-2 text-primary text-weight-medium"
          class="q-mb-md rounded-borders overflow-hidden"
        >
          <q-card flat bordered>
            <q-card-section class="q-pa-none">
            {{ paneles }}
              <q-markup-table flat wrap-cells class="modern-table">
                <thead>
                  <tr>
                    <th class="text-left">Ubicación</th>
                    <th class="text-left">Panel</th>
                    <th class="text-center">Largo (m)</th>
                    <th class="text-center">Alto (m)</th>
                    <th class="text-right">M²</th>
                    <th class="text-right">Total</th>
                    <th class="text-center" width="80">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(panel, index) in paneles" :key="index">
                    <tr class="table-row-hover">
                      <td class="text-left">
                        <q-chip
                          size="sm"
                          :color="getUbicacionColor(panel.ubicacion)"
                          text-color="white"
                          dense
                        >
                          {{ getUbicacion(panel.ubicacion) }}
                        </q-chip>
                      </td>
                      <td class="text-left">
                        <div class="product-cell">
                          <div class="product-name">
                            {{ panel.producto?.label ?? panel.producto.B1_DESC }}
                          </div>
                        </div>
                      </td>
                      <td class="text-center">{{ numberFormat(panel.largo, true) }}</td>
                      <td class="text-center">{{ numberFormat(panel.alto, true) }}</td>
                      <td class="text-right text-weight-medium">
                        {{ numberFormat(panel.m2, true) }}
                      </td>
                      <td class="text-right text-weight-bold text-primary">
                        {{ numberFormat(panel.total) }}
                      </td>
                      <td class="text-center">
                        <q-btn
                          flat
                          dense
                          round
                          icon="delete"
                          size="sm"
                          color="negative"
                          @click="panelDelete(index)"
                        >
                          <q-tooltip>Eliminar panel</q-tooltip>
                        </q-btn>
                      </td>
                    </tr>
                  </template>

                  <!-- Fila para agregar panel (tipo No Convencional) -->
                  <tr v-if="form.tipo === 'nconv'" class="add-row">
                    <td>
                      <GltnSelect
                        dense
                        v-model="panel.ubicacion"
                        label="Ubicacion"
                        :options="ubicaciones"
                        class="q-ma-xs"
                      />
                    </td>
                    <td>
                      <GltnSelectPanel
                        dense
                        v-model="panel.producto"
                        label="Panel"
                        class="q-ma-xs"
                      />
                    </td>
                    <td>
                      <GltnInputNumber
                        name="Largo"
                        dense
                        v-model.number="panel.largo"
                        hide-hint
                        label="Largo"
                        suffix="mts"
                        class="q-ma-xs"
                      />
                    </td>
                    <td>
                      <GltnInputNumber
                        name="Alto"
                        dense
                        v-model.number="panel.alto"
                        hide-hint
                        label="Alto"
                        suffix="mts"
                        class="q-ma-xs"
                      />
                    </td>
                    <td class="text-right text-caption text-grey-7">
                      {{ numberFormat(panel.alto * panel.largo, true) }}
                    </td>
                    <td class="text-right text-caption text-grey-7">
                      {{
                        numberFormat(panel?.alto * panel?.largo * panel.producto?.precio)
                      }}
                    </td>
                    <td class="text-center">
                      <q-btn
                        unelevated
                        icon="add"
                        size="sm"
                        color="primary"
                        round
                        @click="panelAdd(true)"
                        class="q-ma-xs"
                      >
                        <q-tooltip>Agregar panel</q-tooltip>
                      </q-btn>
                    </td>
                  </tr>

                  <!-- Fila de totales -->
                  <tr v-if="paneles.length > 0" class="totals-row">
                    <td colspan="4" class="text-right text-weight-bold">TOTALES:</td>
                    <td class="text-right text-weight-bold text-primary">
                      {{ numberFormat(totalM2, true) }} m²
                    </td>
                    <td class="text-right text-weight-bold text-primary">
                      {{ numberFormat(totalPaneles) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </q-markup-table>
            </q-card-section>
          </q-card>
        </q-expansion-item>

        <!-- Sección: Perfilería y Opciones -->
        <q-expansion-item
          icon="settings"
          label="Perfilería y Opciones"
          caption="Selladores, perfilería exterior e interior"
          header-class="bg-grey-2 text-primary text-weight-medium"
          class="q-mb-md rounded-borders overflow-hidden"
        >
          <q-card flat bordered>
            <q-card-section>
              <div class="row q-col-gutter-md">
                <div class="col-12 col-md-6">
                  <q-toggle
                    v-model="form.perfileria_ext"
                    label="Perfilería Exterior"
                    color="primary"
                    @update:model-value="updateVariables()"
                    class="modern-toggle"
                  >
                    <template v-slot:default>
                      <div class="toggle-content">
                        <q-icon name="view_in_ar" size="20px" class="q-mr-sm" />
                        <span>Perfilería Exterior</span>
                        <q-badge
                          v-if="form.perfileria_ext"
                          color="primary"
                          text-color="white"
                          :label="numberFormat(form.perfileria_ext_valor)"
                          class="q-ml-sm"
                        />
                      </div>
                    </template>
                  </q-toggle>
                </div>
                <div class="col-12 col-md-6">
                  <q-toggle
                    v-model="form.perfileria_int"
                    label="Perfilería Interior"
                    color="primary"
                    @update:model-value="updateVariables()"
                    class="modern-toggle"
                  >
                    <template v-slot:default>
                      <div class="toggle-content">
                        <q-icon name="view_in_ar" size="20px" class="q-mr-sm" />
                        <span>Perfilería Interior</span>
                        <q-badge
                          v-if="form.perfileria_int"
                          color="primary"
                          text-color="white"
                          :label="numberFormat(form.perfileria_int_valor)"
                          class="q-ml-sm"
                        />
                      </div>
                    </template>
                  </q-toggle>
                </div>
                <div class="col-12 col-md-6">
                  <div class="calculated-field-inline">
                    <q-icon name="construction" size="20px" />
                    <span class="text-weight-medium">Selladores:</span>
                    <span class="text-primary text-weight-bold">{{
                      numberFormat(form.selladores)
                    }}</span>
                    <q-icon name="help_outline" size="16px" class="q-ml-xs">
                      <q-tooltip>Calculado automáticamente según m²</q-tooltip>
                    </q-icon>
                  </div>
                </div>
                <div class="col-12 col-md-6">
                  <q-file outlined v-model="model" label="Archivo Adjunto" dense>
                    <template v-slot:prepend>
                      <q-icon name="attach_file" />
                    </template>
                  </q-file>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </q-expansion-item>

        <!-- Sección: Otros Productos/Accesorios -->
        <q-expansion-item
          icon="build_circle"
          :label="`Otros Productos / Accesorios (${otrosProductos.length})`"
          :caption="
            otrosProductos.length > 0
              ? `Total: ${numberFormat(totalOtrosProductos)}`
              : 'Sin accesorios agregados'
          "
          header-class="bg-grey-2 text-primary text-weight-medium"
          class="rounded-borders overflow-hidden"
        >
          <q-card flat bordered>
            <q-card-section class="q-pa-none">
              <q-markup-table flat wrap-cells class="modern-table">
                <thead>
                  <tr>
                    <th class="text-left">Producto</th>
                    <th class="text-center">Precio Unit.</th>
                    <th class="text-center">Cantidad</th>
                    <th class="text-right">Subtotal</th>
                    <th class="text-center" width="80">Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(p, index) in otrosProductos" :key="p.id">
                    <tr class="table-row-hover">
                      <td class="text-left">
                        <div class="product-cell">
                          <div class="product-name">{{ p.producto.label }}</div>
                        </div>
                      </td>
                      <td class="text-center">{{ numberFormat(p.producto.precio) }}</td>
                      <td class="text-center">{{ numberFormat(p.cantidad, true) }}</td>
                      <td class="text-right text-weight-bold text-primary">
                        {{ numberFormat(p.subtotal) }}
                      </td>
                      <td class="text-center">
                        <q-btn
                          flat
                          dense
                          round
                          icon="delete"
                          size="sm"
                          color="negative"
                          @click="otrosProductosDelete(index)"
                        >
                          <q-tooltip>Eliminar accesorio</q-tooltip>
                        </q-btn>
                      </td>
                    </tr>
                  </template>

                  <!-- Fila para agregar accesorio -->
                  <tr class="add-row">
                    <td colspan="2">
                      <GltnSelectCamaraAccesorio
                        dense
                        v-model="otroProducto"
                        label="Seleccione producto"
                        class="q-ma-xs"
                      />
                    </td>
                    <td>
                      <GltnInputNumber
                        dense
                        v-model.number="otroProductoCantidad"
                        label="Cantidad"
                        hide-hint
                        :min="1"
                        class="q-ma-xs"
                      />
                    </td>
                    <td colspan="2" class="text-center">
                      <q-btn
                        unelevated
                        label="Agregar"
                        icon="add"
                        size="sm"
                        color="primary"
                        @click="otrosProductosAdd()"
                        :disable="!otroProducto || !otroProductoCantidad"
                        class="q-ma-xs"
                      />
                    </td>
                  </tr>

                  <!-- Fila de total -->
                  <tr v-if="otrosProductos.length > 0" class="totals-row">
                    <td colspan="3" class="text-right text-weight-bold">
                      TOTAL ACCESORIOS:
                    </td>
                    <td class="text-right text-weight-bold text-primary">
                      {{ numberFormat(totalOtrosProductos) }}
                    </td>
                    <td></td>
                  </tr>
                </tbody>
              </q-markup-table>
            </q-card-section>
          </q-card>
        </q-expansion-item>

        <!-- Sección: Precio y Descuentos -->
        <q-expansion-item
          default-opened
          icon="payments"
          label="Precio y Descuentos"
          caption="Configure descuentos comerciales y estratégicos"
          header-class="bg-grey-2 text-primary text-weight-medium"
          class="q-mb-md rounded-borders overflow-hidden"
        >
          <q-card flat bordered>
            <q-card-section>
              <div class="row q-col-gutter-md">
                <!-- PRECIO UNITARIO (readonly) -->
                <div class="col-12 col-md-4">
                  <GltnInputNumber
                    name="Precio Unitario"
                    :model-value="precio_unitario"
                    hide-hint
                    prefix="US$"
                    label="Precio Unitario"
                    readonly
                    filled
                    bg-color="green-1"
                    @update:model-value="validate($event, 'precio_unitario')"
                    :errors="res.getErrors('precio_unitario')"
                  >
                    <template v-slot:prepend>
                      <q-icon name="attach_money" color="positive" />
                    </template>
                  </GltnInputNumber>
                </div>

                <!-- DESCUENTO COMERCIAL (editable) -->
                <div class="col-12 col-md-4">
                  <GltnInputNumber
                    v-model.number="form.descuento_comercial"
                    label="Descuento comercial"
                    suffix="%"
                    @update:model-value="validate($event, 'descuento_comercial')"
                    :errors="res.getErrors('descuento_comercial')"
                  >
                    <template v-slot:prepend>
                      <q-icon name="local_offer" />
                    </template>
                  </GltnInputNumber>
                </div>

                <!-- DESCUENTO ESTRATÉGICO (editable) -->
                <div class="col-12 col-md-4" v-if="canShowEstrategico">
                  <GltnInputNumber
                    v-model.number="form.descuento_estrategico"
                    label="Descuento estratégico"
                    suffix="%"
                    @update:model-value="validate($event, 'descuento_estrategico')"
                    :errors="res.getErrors('descuento_estrategico')"
                  >
                    <template v-slot:prepend>
                      <q-icon name="trending_down" />
                    </template>
                  </GltnInputNumber>
                </div>
              </div>
            </q-card-section>
          </q-card>
        </q-expansion-item>
      </div>

      <!-- Columna lateral: Resumen -->
      <ProductoResumen
        type="camara"
        :form="form"
        :producto="producto"
        :total-paneles="paneles.length"
        :total-m2="totalM2"
        :total-paneles-subtotal="totalPaneles"
        :total-otros-productos="totalOtrosProductos"
        :otros-productos-count="otrosProductos.length"
        :precio-unitario="precio_unitario"
        :validation-progress="validationProgress"
        :validation-progress-text="validationProgressText"
      >
        <template #after-card>
          <ProductoResumenTips>
            <li>Presiona <kbd>Ctrl + S</kbd> para guardar</li>
            <li>Tipo <strong>Convencional</strong> genera paneles automáticamente</li>
            <li>Tipo <strong>No convencional</strong> permite agregar manualmente</li>
          </ProductoResumenTips>
        </template>
      </ProductoResumen>
    </div>

    <!-- Footer con acciones - FIJO -->
    <q-separator />
    <q-card-actions class="q-pa-md actions-fixed bg-white">
      <div class="row full-width q-gutter-sm">
        <div class="col">
          <q-btn
            outline
            label="Cancelar"
            color="grey-7"
            icon="close"
            v-close-popup
            class="full-width"
          />
        </div>
        <div class="col">
          <q-btn
            unelevated
            :label="props.oper === 'add' ? 'Agregar al carrito' : 'Actualizar'"
            :color="res.valid ? 'primary' : 'grey'"
            :icon="props.oper === 'add' ? 'add_shopping_cart' : 'save'"
            @click="cartSave"
            :disable="!res.valid"
            :loading="loading"
            class="full-width"
          >
            <template v-slot:loading>
              <q-spinner-hourglass size="20px" />
            </template>
          </q-btn>
        </div>
      </div>
    </q-card-actions>
    <q-inner-loading :showing="loading">
      <q-spinner-hourglass size="50px" color="primary" />
    </q-inner-loading>
  </q-card>
</template>

<script setup>
import { computed, reactive, ref, onMounted, onUnmounted, watchEffect } from "vue";
import { round } from "mathjs";
import { useCartStore } from "@/stores/useCartStore.js";
import { usePage } from "@inertiajs/vue3";
import { useQuasar } from "quasar";
import ConfigService from "@/services/ConfigService.js";
import GltnInputNumber from "@/components/form/GltnInputNumber.vue";
import GltnSelect from "@/components/form/GltnSelect.vue";
import GltnSelectCamaraAccesorio from "@/components/form/GltnSelectCamaraAccesorio.vue";
import GltnSelectPanel from "@/components/form/GltnSelectPanel.vue";
import numberFormat from "@/helpers/numberFormat";
import ProductoResumen from "../ProductoResumen.vue";
import ProductoResumenTips from "../ProductoResumenTips.vue";
import ProductosCommon from "./components/ProductosCommon.vue";
import suite from "./ProductoCamaraValidation.js";

const $q = useQuasar();
const page = usePage();
const canShowEstrategico = computed(() => page.props?.auth?.can.includes('presupuesto.item.estrategico'));

const props = defineProps({
  oper: String,
  producto: Object,
  presupId: Number,
  formulario: Object,
  isSavedPresup: {
    type: Boolean,
    default: false,
  },
});
const emits = defineEmits(["added", "updated"]);
const otroProducto = ref(null);
const otroProductoCantidad = ref(0);
const otrosProductos = ref([]);
const loading = ref(false);
const panel = reactive({
  ubicacion: "",
  producto: "",
  largo: 0,
  alto: 0,
  tipo: "panelCamara",
});
const variables = reactive({
  selladores: 0,
  perfileria: 0,
});

const tipos = [
  { label: "Convencional", value: "conv" },
  { label: "No convencional", value: "nconv" },
];
const ubicaciones = [
  { label: "Muro Compartido", value: "muroCompartido" },
  { label: "Muro Divisor", value: "muroDivisor" },
  { label: "Muro", value: "muro" },
  { label: "Techo", value: "techo" },
  { label: "Piso", value: "piso" },
];
const getUbicacion = (x) => {
  return ubicaciones.find((y) => y.value == x)?.label || x;
};

const getUbicacionColor = (ubicacion) => {
  const colors = {
    muroCompartido: "blue-6",
    muroDivisor: "blue-7",
    muro: "blue-8",
    techo: "orange-6",
    piso: "brown-6",
  };
  return colors[ubicacion] || "grey-6";
};

const form = reactive({
  alicuota_id: 2,
  empresa_id: "",
  tipo_venta_id: "",
  tipo: "conv",
  ancho: 0,
  largo: 0,
  alto: 0,
  m3: 0,
  panel: "",
  accesorios: [],
  perfileria_ext_valor: 0,
  perfileria_int_valor: 0,
  perfileria_ext: false,
  perfileria_int: false,
  selladores: 0,
  iluminacion: false,
  kit_baja: false,
  kit_techo: false,
  valvula: false,
  resistencia: false,
  cortina: false,
  hongos: false,
  cantidad: 1,
  precio_unitario: 0,
  descuento_comercial: 0,
  descuento_estrategico: 0,
  subtotal: 0,
  total: 0,
});
// TITULO
const title = computed(() => (props.oper === "add" ? "Agregar Cámara" : "Editar Cámara"));

const paneles = computed(() => {
  return form.accesorios.length > 0
    ? form.accesorios.filter((x) => x.tipo == "panelCamara")
    : [];
});

const totalPaneles = computed(() => {
  return round(
    paneles.value.reduce((a, b) => a + round(b.total, 2), 0),
    2
  );
});

const totalPanelesUnidades = computed(() => {
  return paneles.value.reduce((a, b) => a + round(b.cantidad, 2), 0);
});

const totalM2 = computed(() =>
  form.accesorios.length > 0
    ? round(
        form.accesorios.reduce((a, b) => a + round(b.m2, 2), 0),
        2
      )
    : 0
);

const totalOtrosProductos = computed(() =>
  round(
    otrosProductos.value.reduce((a, b) => a + Number.parseFloat(b.subtotal), 0),
    2
  )
);

const precio_unitario = computed(() => {
  return (
    round(totalPaneles.value, 2) +
    round(form.perfileria_ext_valor, 2) +
    round(form.perfileria_int_valor, 2) +
    round(form.selladores, 2) +
    totalOtrosProductos.value
  );
});

const subtotal = computed(() => {
  return round(precio_unitario.value, 2) * round(form.cantidad, 2);
});

const descuento_monto = computed(() => {
  // Descuento comercial
  const desc1 = subtotal.value * (form.descuento_comercial / 100);
  const precioConDesc1 = subtotal.value - desc1;
  // Descuento estratégico sobre el precio ya descontado
  const desc2 = precioConDesc1 * (form.descuento_estrategico / 100);
  return round(desc1 + desc2, 2);
});

const total = computed(() => {
  return round(subtotal.value - descuento_monto.value, 2);
});

// Actualizar automaticamente form.total y form.subtotal cuando cambian
watchEffect(() => {
  form.total = total.value;
  form.subtotal = subtotal.value;
});
// calculo m3
const calculoM3 = () => {
  form.m3 = round(form.ancho * form.largo * form.alto, 2);
  form.precio_unitario = round(form.cantidad * form.precio_unitario, 2);
  form.total = round(form.cantidad * form.precio_unitario, 2);
};
// VALIDACION
const res = ref();
res.value = suite.get();
const validate = (value, name) => {
  res.value = suite(name, form);
  calculoM3();
};

const getVariablesCamara = async () => {
  loading.value = true;
  variables.perfileria = await ConfigService.getPerfileria();
  variables.selladores = await ConfigService.getSelladores();
  loading.value = false;
};

const updateVariables = () => {
  form.selladores = variables.selladores * totalM2.value;

  const valorPerfileria = totalPaneles.value * variables.perfileria;
  form.perfileria_ext_valor = form.perfileria_ext ? valorPerfileria : 0;
  form.perfileria_int_valor = form.perfileria_int ? valorPerfileria : 0;
};

const setValues = () => {
  for (let key in props.formulario) {
    if (key === "accesorios") {
      form.accesorios = props.formulario[key].filter((x) => x.tipo === "panelCamara");
      otrosProductos.value = props.formulario[key].filter(
        (x) => x.tipo === "accesorioCamara"
      );
      continue;
    }
    form[key] = props.formulario[key];
  }
};

// Progress de validación
const validationProgress = computed(() => {
  const requiredFields = ["empresa_id", "alicuota_id", "tipo_venta_id"];
  let completed = 0;
  let total = requiredFields.length;

  for (const field of requiredFields) {
    if (form[field]) completed++;
  }

  // Verificar si tiene paneles
  if (paneles.value.length > 0) {
    completed++;
  }
  total++;

  return completed / total;
});

const validationProgressText = computed(() => {
  const percent = Math.round(validationProgress.value * 100);
  return `Formulario ${percent}% completo`;
});

onMounted(async () => {
  await getVariablesCamara();
  if (props.oper === "edit") {
    setValues();
  }
  validate();

  // Agregar keyboard shortcut
  document.addEventListener("keydown", handleKeyboardShortcut);
});

onUnmounted(() => {
  document.removeEventListener("keydown", handleKeyboardShortcut);
});

const handleKeyboardShortcut = (e) => {
  if ((e.ctrlKey || e.metaKey) && e.key === "s") {
    e.preventDefault();
    if (res.value.valid) {
      cartSave();
    }
  }
};

//gestion de paneles
const panelAdd = (justOne = false) => {
  if (form.tipo == "conv" && !justOne) {
    form.accesorios = [];
    const ubicacionMuro = ubicaciones.find((x) => x.value == "muro");
    const ubicacionTecho = ubicaciones.find((x) => x.value == "techo");
    const { largo, alto, ancho, panel } = form;
    if (!panel.value || !largo || !alto || !ancho) {
      $q.notify({
        type: "negative",
        message: "Complete todos los campos.",
      });
      return;
    }
    const valores = [
      { ubicacion: ubicacionMuro, largo, alto },
      { ubicacion: ubicacionMuro, largo, alto },
      { ubicacion: ubicacionMuro, largo: ancho, alto },
      { ubicacion: ubicacionMuro, largo: ancho, alto },
      { ubicacion: ubicacionTecho, largo, alto: ancho },
    ];
    for (const x of valores) {
      panelesPush(
        x.ubicacion.value,
        form.panel.value,
        x.largo,
        x.alto,
        form.panel.precio,
        form.panel
      );
    }
  } else {
    if (!panel.producto.value) {
      $q.notify({
        type: "negative",
        message: "Seleccione un panel.",
      });
      return;
    }
    panelesPush(
      panel.ubicacion.value,
      panel.producto.value,
      panel.largo,
      panel.alto,
      panel.producto.precio,
      panel.producto
    );
  }
  updateVariables();
};

const panelesPush = (ubicacion, producto_id, largo, alto, precio, producto) => {
  form.accesorios.push({
    ubicacion,
    producto_id,
    largo,
    alto,
    m2: alto * largo,
    total: round(alto * largo * precio, 2),
    producto,
    tipo: "panelCamara",
  });
};

const panelDelete = (id) => {
  form.accesorios.splice(
    form.accesorios.findIndex(function (i) {
      return i.id === id;
    }),
    1
  );
};

const otrosProductosAdd = () => {
  otrosProductos.value.push({
    producto: { ...otroProducto.value },
    cantidad: otroProductoCantidad.value,
    tipo: "accesorioCamara",
    subtotal: otroProducto.value.precio * otroProductoCantidad.value,
  });
  updateVariables();
};

const otrosProductosDelete = (index) => {
  otrosProductos.value.splice(index, 1);
  updateVariables();
};

// GESTION DE CART
const cartStore = useCartStore();
const cartSave = () => {
  if (props.oper === "add") {
    cartAdd();
  } else {
    cartUpdate();
  }
};

const otrosProductosParse = () => {
  return otrosProductos.value.map((x) => {
    return {
      producto_id: x.producto.id,
      total: x.subtotal,
      producto: x.producto,
      tipo: "accesorioCamara",
    };
  });
};

const cartUpdate = async () => {
  form.total = total.value;
  form.accesorios = [...form.accesorios, ...otrosProductosParse()];
  cartStore.itemUpdate(
    {
      form: { ...form },
      producto: { ...props.producto },
    },
    props.isSavedPresup,
    props.presupId
  );
  emits("updated");
};
const cartAdd = async () => {
  form.total = total.value;
  form.accesorios = [...form.accesorios, ...otrosProductosParse()];
  await cartStore.itemAdd(
    {
      form: { ...form },
      producto: { ...props.producto },
    },
    props.isSavedPresup,
    props.presupId
  );
  emits("added");
};

</script>

<style lang="scss" scoped>
@use 'sass:color';
.producto-camara-form {
  border-radius: 16px;
  overflow: hidden;

  // Gradiente para el header
  .bg-gradient-primary {
    background: linear-gradient(
      135deg,
      var(--q-primary) 0%,
      color.adjust(#1976d2, $lightness: -10%) 100%
    );
  }

  // Toolbar fijo arriba
  .toolbar-fixed {
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  // Contenido scrolleable
  .content-scrollable {
    flex: 1;
    overflow: hidden;
  }

  .scroll-area {
    overflow-y: auto;
    max-height: 100%;

    &::-webkit-scrollbar {
      width: 8px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #888;
      border-radius: 4px;

      &:hover {
        background: #555;
      }
    }
  }

  // Acciones fijas abajo
  .actions-fixed {
    flex-shrink: 0;
    box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.1);
  }
}

// Sticky summary en desktop
.sticky-summary {
  position: sticky;
  top: 20px;
}

// Card de resumen
.summary-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

// Filas del resumen
.summary-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  gap: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  }

  span:first-child {
    flex: 1;
  }

  span:last-child {
    text-align: right;
    word-break: break-word;
  }
}

// Tablas modernas
.modern-table {
  border-radius: 8px;
  overflow: hidden;

  :deep(thead) {
    background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);

    tr th {
      color: white;
      font-weight: 600;
      padding: 12px;
      text-transform: uppercase;
      font-size: 0.75rem;
    }
  }

  :deep(tbody) {
    tr {
      transition: background-color 0.2s ease;

      &.table-row-hover:hover {
        background-color: rgba(25, 118, 210, 0.04);
      }

      &.add-row {
        background-color: #fafafa;
        border-top: 2px solid #1976d2;
      }

      &.totals-row {
        background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
        font-size: 1rem;

        td {
          padding: 12px;
          border-top: 2px solid #1976d2;
        }
      }
    }
  }
}

// Celdas de producto
.product-cell {
  .product-name {
    font-weight: 500;
    color: #212121;
  }
}

// Toggles modernos
.modern-toggle {
  padding: 12px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  transition: all 0.3s ease;

  &:hover {
    background-color: rgba(25, 118, 210, 0.04);
  }

  .toggle-content {
    display: flex;
    align-items: center;
    gap: 8px;
  }
}

// Radio groups modernos
.modern-radio-group {
  :deep(.q-radio) {
    padding: 8px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    margin-right: 8px;
    transition: all 0.3s ease;

    &:hover {
      background-color: rgba(25, 118, 210, 0.04);
    }
  }
}

// Campo calculado inline
.calculated-field-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px;
  background: linear-gradient(135deg, #f5f5f5 0%, #e8eaf6 100%);
  border-radius: 8px;
  border-left: 4px solid #1976d2;
}

// Badge de ayuda
kbd {
  background: #f4f4f4;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 0.85em;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

// Expansion items
:deep(.q-expansion-item) {
  border: 1px solid rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  &.q-expansion-item--expanded {
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  }

  .q-expansion-item__container {
    .q-item {
      min-height: 56px;
    }
  }
}

// Mejora de tipografía
.text-white-7 {
  color: rgba(255, 255, 255, 0.7);
}

// Responsive
@media (max-width: 1023px) {
  .producto-camara-form {
    border-radius: 0;
  }

  .sticky-summary {
    position: relative;
    top: 0;
  }
}

// Animaciones
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
